import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

// eslint-disable-next-line no-unused-vars
const registerSentryClient = (fragmentId: string, client: Sentry.BrowserClient): void => {
    window.Applant.sentryClients[fragmentId] = client;
};

if (!window.Sentry) {
    window.Sentry = Sentry;
}

if (!window.Applant.sentryClients) {
    window.Applant.sentryClients = {};
}

if (!window.Applant.registerSentryClient) {
    window.Applant.registerSentryClient = registerSentryClient;
}

Sentry.init({
    dsn: window?.Applant?.data?.jugo?.sentryDSN,
    ...(window?.Applant?.data?.jugo?.sentryTracingEnabled && {
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: [window?.location?.origin],
            }),
        ],
        tracesSampleRate: window?.Applant?.data?.jugo?.sentrySampleRate,
    }),
    sampleRate: 1,
    autoSessionTracking: true,

    release: `${window?.Applant?.data?.jugo?.release}`,
    environment: window?.Applant?.data?.jugo?.environment,
    debug: false,
    attachStacktrace: true,
    denyUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Chrome extensions
        /chrome-extension:\//i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Safari extension
        /safari-extension:\//i,
        // Other plugins
    ],
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
    ignoreErrors: [],
    beforeSend(event): Sentry.Event | null {
        let stacktraceFrames: Sentry.StackFrame[] | null = null;
        let causingErrorFilename: string;
        let fragmentId: string;

        try {
            stacktraceFrames = event.exception?.values?.[0].stacktrace?.frames;
            causingErrorFilename =
                stacktraceFrames &&
                new URL(stacktraceFrames?.[stacktraceFrames.length - 1]?.filename).pathname;
            fragmentId = window.Applant?.fragmentScriptsMap?.[causingErrorFilename];
        } catch (err) {
            return event;
        }

        if (stacktraceFrames && causingErrorFilename && fragmentId) {
            try {
                // eslint-disable-next-line no-unused-expressions
                window.Applant?.sentryClients?.[fragmentId]?.captureEvent(event);
                return null;
            } catch (err) {
                return {
                    ...event,
                    extra: {
                        ...event.extra,
                        hint: `consider to update version of react-fragment-scripts and register sentry client in ${fragmentId}`,
                    },
                };
            }
        }

        return event;
    },
});

window.logToSentry = Sentry.captureException;
